import axios from 'axios';

const useAxios = () => {
	// https://evening-lake-03295.herokuapp.com/
	const client = axios.create({
		baseURL: 'https://evening-lake-03295.herokuapp.com/',
	});
	return { client };
};

export default useAxios;
